import React from 'react';
import PropTypes from 'prop-types';
import makeStyles from '@mui/styles/makeStyles';
import Styles from './styles';

const useStyles = makeStyles(Styles);

function PortalFormWrapper({ children }) {
  const classes = useStyles();

  return <div className={classes.portalFormWrapper}>{children}</div>;
}

PortalFormWrapper.propTypes = {
  children: PropTypes.element.isRequired,
};

export default PortalFormWrapper;
